import React from 'react'
import "./contact.css"


import { BsFillEnvelopeFill,BsFillTelephoneInboundFill,BsLinkedin,BsGithub} from "react-icons/bs";
import Gitstackcalender from './Gitstackcalender';
import Stacks from './Stacks';


export default function Contact() {

  return (
    <>
    <div className='contactcss'>

          <div >
          <Gitstackcalender/>
          </div>

          <div>
            <Stacks/>
          </div>
         
          <h1> Contact Me</h1>


          <div className='icons'>

                <div 
                  
                  className="iconstyle"
                  >

                    <a><h1 className='icons-photo'><BsFillTelephoneInboundFill/></h1></a>
                   <a> <h1   className='icons-photo1' id='phone-num'> +91 - 8299263085  </h1></a>
                </div>  
            

                <div 
                
                    className="iconstyle"
                    // style={{display:"flex",justifyContent:"space-evenly" }}
                >
                    <a href='https://mail.google.com/mail/sumer.ki359@gmail.com'><h1 className='icons-photo'><BsFillEnvelopeFill /></h1></a>
                   <a href='https://mail.google.com/mail/sumer.ki359@gmail.com'><h1  className='icons-photo1' id='phone-email'>sumer
                  .ki359@gmail
                  .com</h1></a>

                </div>

                <div
                
                  className="iconstyle"
                >
                 

                  <a href ="https://www.linkedin.com/in/kailash-chandra/" target="_blank" > 

                  <h1 className='icons-photo'><BsLinkedin /></h1>
                   </a>
                <a href ="https://www.linkedin.com/in/kailash-chandra/" target="_blank" > 

                  <h1  className='icons-photo1' id='phone-linkedin'>  Linkedin</h1>
                </a>

                </div>
          
                <div 
                
                  className="iconstyle"
                >
                  <a href ="https://github.com/Gurjazz18"
                  target="_blank" 
                > 

               <h1 className='icons-photo' >
                <BsGithub /></h1>
                </a>
                

                <a href ="https://github.com/Gurjazz18"
                  target="_blank" 
                > 

                <h1  className='icons-photo1' id='phone-git'>Github</h1>
                </a>

                </div>
           
              

              
             

 
   
          </div>



       


    </div>


   
  
  
   
    </>
  )
}
